/* taio-wideo-leniwe
   Wideo dostaje adres pliku dopiero, gdy zbliza sie do ekranu (400 px wczesniej).
   Wczesniej przegladarka ciagnela kazdy plik od razu po wejsciu na karte,
   do 15 MB na karte oleju z sardeli (pomiar 2026-10-05).
   Uzycie: <video data-tio-src="..." preload="none">, opcjonalnie data-tio-auto,
   gdy wideo ma grac samo (bez dzwieku, w petli). */
(function () {
  if (window.__tioWideoLeniwe) return;
  window.__tioWideoLeniwe = true;

  function laduj(v) {
    if (v.dataset.tioGotowe) return;
    v.dataset.tioGotowe = '1';
    var src = v.getAttribute('data-tio-src');
    if (!src) return;
    v.preload = 'metadata';
    v.src = src;
    if (v.hasAttribute('data-tio-auto')) {
      v.muted = true;
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    }
  }

  function start() {
    var lista = document.querySelectorAll('video[data-tio-src]');
    if (!lista.length) return;
    if (!('IntersectionObserver' in window)) {
      for (var i = 0; i < lista.length; i++) laduj(lista[i]);
      return;
    }
    var io = new IntersectionObserver(function (wpisy) {
      wpisy.forEach(function (w) {
        if (w.isIntersecting) {
          laduj(w.target);
          io.unobserve(w.target);
        }
      });
    }, { rootMargin: '400px 0px' });
    for (var j = 0; j < lista.length; j++) io.observe(lista[j]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
